function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Designs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stimson-UN-Handbook-Desktop-1",
  transform: "translate(-1230.000000, -21.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Handbook/Unselected",
  transform: "translate(1200.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic-library-books-24px-copy",
  transform: "translate(30.000000, 21.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 19.68 0 19.68 19.68 0 19.68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.28,4.92 L1.64,4.92 L1.64,16.4 C1.64,17.302 2.378,18.04 3.28,18.04 L14.76,18.04 L14.76,16.4 L3.28,16.4 L3.28,4.92 Z M16.4,1.64 L6.56,1.64 C5.658,1.64 4.92,2.378 4.92,3.28 L4.92,13.12 C4.92,14.022 5.658,14.76 6.56,14.76 L16.4,14.76 C17.302,14.76 18.04,14.022 18.04,13.12 L18.04,3.28 C18.04,2.378 17.302,1.64 16.4,1.64 Z M15.58,9.02 L7.38,9.02 L7.38,7.38 L15.58,7.38 L15.58,9.02 Z M12.3,12.3 L7.38,12.3 L7.38,10.66 L12.3,10.66 L12.3,12.3 Z M15.58,5.74 L7.38,5.74 L7.38,4.1 L15.58,4.1 L15.58,5.74 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})))));

function SvgHandbook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8365547C-C59B-417C-A342-C0D7FC32059E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbook);
export default __webpack_public_path__ + "static/media/handbook.afd50f2f.svg";
export { ForwardRef as ReactComponent };